import { ActivityAPI } from '../../utils/API/ActivityAPI';
import { takeLatest, takeEvery, put, call } from 'redux-saga/effects';
import { GET_ACTIVITY, ADD_COMMENT } from '../constants/activity.constants';
import { activityChanged, commentReceived, setActivityLoading } from '../actions/activity.actions';
import ActivityEntry from '../../utils/models/ActivityEntry';

const api = new ActivityAPI();

function* getActivitySaga({ entity, objectId }) {
	try {
		yield put(setActivityLoading(entity, objectId, true));
		const entries = yield call([api, api.getForObject], entity, objectId);
		yield put(activityChanged(entity, objectId, entries.map(e => new ActivityEntry(e))));
	} catch (error) {
		yield put(setActivityLoading(entity, objectId, false));
	}
}

function* addCommentSaga({ entity, objectId, text }) {
	const entry = yield call([api, api.addComment], entity, objectId, text);
	yield put(commentReceived(new ActivityEntry(entry)));
}

export const activitySagas = [
	takeLatest(GET_ACTIVITY, getActivitySaga),
	takeEvery(ADD_COMMENT, addCommentSaga)
];
